import * as React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

const SubheaderStyles = styled.div`
  background-color: #310542;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    padding: 10px;
    color: #c29dc1;
    font-family: "Cabin", sans-serif;
    font-size: 10.48px;
  }

  a {
    font-family: "Cabin", sans-serif;
    text-decoration: none;
    font-weight: bold;
    color: inherit;
  }
`

function Subheader() {
  return (
    <>
      <SubheaderStyles>
        <p>
          Heights Ateneo — The Official Literary and Artistic Publication and
          Organization of the Ateneo de Manila University
        </p>
      </SubheaderStyles>
    </>
  )
}

export default Subheader
